"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3933],{

/***/ 1955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47411);
/* harmony import */ var hooks_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22699);
/* harmony import */ var _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55287);
/* harmony import */ var utils_methods__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84918);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n    padding: calc(0.5rem - 2px) 0;\n\n    &:hover {\n        text-decoration: underline;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-c291d46c-0"
})(_templateObject(), _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.WHITE */ .DM.WHITE);
var Link = function(_param) {
    var href = _param.href, to = _param.to, id = _param.id, children = _param.children, onClick = _param.onClick, _target = _param.target, target = _target === void 0 ? "_self" : _target, _app = _param.app, app = _app === void 0 ? "Internal" : _app, _isAnchor = _param.isAnchor, isAnchor = _isAnchor === void 0 ? false : _isAnchor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "href",
        "to",
        "id",
        "children",
        "onClick",
        "target",
        "app",
        "isAnchor"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,hooks_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useRouter */ .tv)(app), 1), push = ref[0];
    if (!href && !to && !onClick && isAnchor === false) return null;
    var routeTo = function(to) {
        if (!to) return;
        var path = to.path, url = to.url;
        if (path) {
            push(path, url);
        } else {
            push(url);
        }
    };
    if (isAnchor && children) {
        var anchor = (0,utils_methods__WEBPACK_IMPORTED_MODULE_7__/* .toAnchor */ .K2)(children.toString());
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            id: anchor,
            href: "#" + anchor,
            target: target
        }, props), {
            children: children
        }));
    } else if (onClick) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            id: id,
            href: "#",
            onClick: onClick
        }, props), {
            children: children
        }));
    } else if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            id: id,
            href: href,
            target: target
        }, props), {
            children: children
        }));
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            id: id,
            href: "#",
            onClick: function() {
                return routeTo(to);
            },
            target: target
        }, props), {
            children: children
        }));
    }
};


/***/ }),

/***/ 51370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PartnershipAdminLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47411);
/* harmony import */ var _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73550);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: 0.1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    align-items: center;\n    border-left: 1px solid #fff;\n    padding-left: 1rem;\n    height: 30px;\n    calc(0.5rem - 2px) 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Text = _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv;
var LogoContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d0994351-0"
})(_templateObject());
var LogoText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d0994351-1"
})(_templateObject1());
var LogoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d0994351-2"
})(_templateObject2());
var PartnershipAdminLogo = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LogoWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LogoContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    width: "65",
                    height: "80",
                    viewBox: "-35 0 150 80",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, props), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M13.4784 13.7388C-4.46584 32.0315 -4.49255 61.6727 13.397 80L41.2883 79.9999L27.424 65.8663C17.1551 55.3975 17.1554 38.4242 27.4249 27.9555C37.6945 17.4868 54.3452 17.4868 64.6154 27.9555V3.98743C47.7398 -3.60461 27.3049 -0.355827 13.4784 13.7388ZM64.6147 27.9553V60.7205H32.473L64.6147 27.9553Z",
                        fill: "#fff"
                    })
                }))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LogoText, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                    children: "Partnership Administration"
                })
            })
        ]
    });
};


/***/ }),

/***/ 20865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PJ": function() { return /* binding */ LeftContent; },
  "W_": function() { return /* binding */ Navigation; },
  "du": function() { return /* binding */ RightContent; },
  "N6": function() { return /* binding */ StyledCol; },
  "Y6": function() { return /* binding */ StyledNav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(47411);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/constants.mjs
var constants = __webpack_require__(55287);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Grid/FullPageGrid.mjs + 4 modules
var FullPageGrid = __webpack_require__(61827);
// EXTERNAL MODULE: ./hooks/hooks.ts
var hooks = __webpack_require__(22699);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/link/Link.tsx
var Link = __webpack_require__(1955);
// EXTERNAL MODULE: ./api/auth.ts
var auth = __webpack_require__(93736);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/v2/Actions/Button/Button.mjs + 1 modules
var Button = __webpack_require__(61205);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/tab/TabListContainer.tsx
var TabListContainer = __webpack_require__(93635);
;// CONCATENATED MODULE: ./components/tab/ButtonTabList.tsx






var ButtonTabList = function(_param) {
    var tabs = _param.tabs, selectedTab = _param.selectedTab, handleMenuNav = _param.handleMenuNav, props = (0,_object_without_properties/* default */.Z)(_param, [
        "tabs",
        "selectedTab",
        "handleMenuNav"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabListContainer/* TabListContainer */.E, {
                children: tabs.map(function(tab, i) {
                    var variant = tabs.length > 1 && selectedTab === i ? "primary" : "secondary";
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            return handleMenuNav(i);
                        },
                        variant: variant,
                        children: tab.label
                    }, tab.label);
                })
            })
        }))
    });
};

;// CONCATENATED MODULE: ./components/navigation/Menu.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 1.5rem;\n\n    button[aria-selected='true'] {\n        border-bottom: none;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledMenuContainer = (0,styled_components_browser_esm/* default */.ZP)(ButtonTabList).withConfig({
    componentId: "sc-63284f47-0"
})(_templateObject());
var MenuContainer = function(param) {
    var tabs = param.tabs, app = param.app;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useMenu */.H9)(tabs, app), 2), selectedTab = ref[0], handleMenuNav = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuContainer, {
        tabs: tabs,
        selectedTab: selectedTab,
        handleMenuNav: handleMenuNav,
        "data-cy-menu": true
    });
};

// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
;// CONCATENATED MODULE: ./components/navigation/portal/Menu.tsx

function Menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media only screen and (max-width: ",
        ") {\n        display: none;\n    }\n"
    ]);
    Menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Menu_StyledMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe2ad22e-0"
})(Menu_templateObject(), hooks/* smallScreenWidth */.IW + "px");
var Menu = function() {
    var ref;
    var ref1 = (0,next_auth_react.useSession)(), session = ref1.data;
    var tabs = [
        {
            label: "Dashboard",
            url: "/partners/".concat(session === null || session === void 0 ? void 0 : (ref = session.partner) === null || ref === void 0 ? void 0 : ref.id, "/dashboard"),
            match: /^\/portal\/partners\/.*\/dashboard/
        }, 
    ];
    var doLogout = function() {
        auth/* default.logout */.ZP.logout("DevPortal");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_StyledMenuContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuContainer, {
                    tabs: tabs,
                    app: "DevPortal"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                variant: "secondary",
                onClick: doLogout,
                "data-cy-sign-out": true,
                children: "Sign out"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Typography/Typography.mjs
var Typography = __webpack_require__(73550);
;// CONCATENATED MODULE: ./components/logo/DevelopersLogo.tsx



function DevelopersLogo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0.1rem;\n"
    ]);
    DevelopersLogo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: center;\n    border-left: 1px solid #fff;\n    padding-left: 1rem;\n    height: 30px;\n    calc(0.5rem - 2px) 0;\n    padding-top: 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Text = Typography/* Text */.xv;
var LogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a87f267b-0"
})(DevelopersLogo_templateObject());
var LogoText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a87f267b-1"
})(_templateObject1());
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a87f267b-2"
})(_templateObject2());
var DevelopersLogo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    width: "65",
                    height: "80",
                    viewBox: "-35 0 150 80",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M13.4784 13.7388C-4.46584 32.0315 -4.49255 61.6727 13.397 80L41.2883 79.9999L27.424 65.8663C17.1551 55.3975 17.1554 38.4242 27.4249 27.9555C37.6945 17.4868 54.3452 17.4868 64.6154 27.9555V3.98743C47.7398 -3.60461 27.3049 -0.355827 13.4784 13.7388ZM64.6147 27.9553V60.7205H32.473L64.6147 27.9553Z",
                        fill: "#fff"
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    children: "Developers"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/navigation/portal/Navigation.tsx

function Navigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .portal-navigation-grid {\n        background-color: #0f0f0f;\n    }\n\n    @media only screen and (max-width: ",
        ") {\n        .portal-navigation-grid {\n            width: 96%;\n            margin: 0;\n            padding: 0;\n        }\n    }\n"
    ]);
    Navigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StyledPortalNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aa0d1d3-0"
})(Navigation_templateObject(), hooks/* smallScreenWidth */.IW + "px");
var PortalNavigation = function(param) {
    var isAuthenticated = param.isAuthenticated;
    var ref = (0,next_auth_react.useSession)(), session = ref.data;
    var pageMode = (0,hooks/* usePageMode */.E2)().pageMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPortalNav, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNav, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullPageGrid/* FullPageGrid */.gc, {
                className: "portal-navigation-grid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCol, {
                    size: 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftContent, {
                            children: isAuthenticated && pageMode === "View" && session && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                to: {
                                    path: "/partners/[id]/dashboard",
                                    url: "/partners/".concat(session.partner.id, "/dashboard")
                                },
                                app: "DevPortal",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DevelopersLogo, {})
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(DevelopersLogo, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent, {
                            children: isAuthenticated && pageMode === "View" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {})
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./components/logo/PartnershipAdminLogo.tsx
var PartnershipAdminLogo = __webpack_require__(51370);
;// CONCATENATED MODULE: ./components/navigation/internal/Menu.tsx

function internal_Menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: fit-content;\n"
    ]);
    internal_Menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-ab790965-0"
})(internal_Menu_templateObject());
var Menu_Menu = function() {
    var tabs = [
        {
            label: "Partners",
            url: "/partners",
            match: /^\/internal\/(partners)/
        },
        {
            label: "Tiers",
            url: "/tiers",
            match: /^\/internal\/(tiers)/
        },
        {
            label: "Products",
            url: "/products",
            match: /^\/internal\/(products)/
        },
        {
            label: "Collection Library",
            url: "/collections/library",
            match: /^\/internal\/(collections)\/(library)/
        }, 
    ];
    var doLogout = function() {
        auth/* default.logout */.ZP.logout("Internal");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuContainer, {
                tabs: tabs,
                app: "Internal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                variant: "secondary",
                onClick: doLogout,
                "data-cy-sign-out": true,
                children: "Sign out"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/navigation/internal/Navigation.tsx







var InternalNavigation = function(param) {
    var isAuthenticated = param.isAuthenticated;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNav, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullPageGrid/* FullPageGrid */.gc, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCol, {
                size: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftContent, {
                        children: isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            to: {
                                url: "/partners"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnershipAdminLogo/* PartnershipAdminLogo */.X, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent, {
                        children: isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu, {})
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/navigation/Navigation.tsx

function navigation_Navigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0.7rem;\n\n    a:hover {\n        text-decoration: none;\n    }\n"
    ]);
    navigation_Navigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Navigation_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    width: 100%;\n    min-height: 50px;\n    top: 0;\n    background-color: ",
        ";\n    z-index: 1000;\n"
    ]);
    Navigation_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Navigation_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 1.5rem;\n"
    ]);
    Navigation_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 0.5rem;\n\n    span {\n        font-size: 1rem;\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var LeftContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-761b0ba4-0"
})(navigation_Navigation_templateObject());
var StyledNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-761b0ba4-1"
})(Navigation_templateObject1(), constants/* COLORS.BLACK */.DM.BLACK);
var RightContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-761b0ba4-2"
})(Navigation_templateObject2());
var StyledCol = (0,styled_components_browser_esm/* default */.ZP)(FullPageGrid/* FullPageGrid.Col */.gc.Col).withConfig({
    componentId: "sc-761b0ba4-3"
})(_templateObject3());
var Navigation = function(param) {
    var isAuthenticated = param.isAuthenticated, app = param.app;
    var environment = (0,hooks/* useEnvironment */.O7)().environment;
    if (app === "DevPortal") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PortalNavigation, {
            isAuthenticated: isAuthenticated
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalNavigation, {
            environment: environment,
            isAuthenticated: isAuthenticated
        });
    }
};


/***/ }),

/***/ 93635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TabListContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47411);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    gap: 1rem;\n    margin-right: 1rem;\n    div[role='tablist'] {\n        overflow: hidden;\n        overflow-x: scroll;\n        scrollbar-width: none; /* Firefox */\n        -ms-overflow-style: none; /* Internet Explorer 10+ */\n\n        &::-webkit-scrollbar {\n            /* WebKit */\n            width: 0;\n            height: 0;\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var TabListContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-458bdda2-0"
})(_templateObject());


/***/ }),

/***/ 70471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var hooks_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22699);
/* harmony import */ var _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73550);
/* harmony import */ var _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55287);
/* harmony import */ var _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65119);
/* harmony import */ var _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38833);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47411);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    z-index: 3000;\n    background: ",
        ";\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    color: ",
        ";\n    min-width: 20%;\n\n    span {\n        color: ",
        ";\n    }\n    margin: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    align-items: center;\n\n    div {\n        padding: 1.5rem;\n    }\n    span {\n        color: ",
        ";\n    }\n\n    ul {\n        list-style: none;\n    }\n    ul li {\n        margin-bottom: 0.5rem;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    cursor: pointer;\n    text-align: right;\n    position: absolute;\n    top: 5px;\n    right: 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Text = _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv;
var StyledToastContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-949e4aac-0"
})(_templateObject(), _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_6__/* .COLORS.WHITE */ .DM.WHITE, _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_6__/* .COLORS.BLACK */ .DM.BLACK, _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_6__/* .COLORS.BLACK */ .DM.BLACK);
var StyledNotification = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_7__/* .Notification */ .P).withConfig({
    componentId: "sc-949e4aac-1"
})(_templateObject1(), _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_6__/* .COLORS.BLACK */ .DM.BLACK);
var StyledCloseButton = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-949e4aac-2"
})(_templateObject2());
var Toast = function() {
    var ref = (0,hooks_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMessages */ .y_)(), message = ref.message, removeMessage = ref.removeMessage;
    var messages = message ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
            children: message.messages.map(function(value, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                        children: value
                    })
                }, i);
            })
        })
    }) : undefined;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!message) return;
        var timeout = setTimeout(function() {
            removeMessage();
        }, 5000);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        message
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: messages && message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledToastContainer, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCloseButton, {
                    onClick: function() {
                        return removeMessage();
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_8__/* .Close */ .x, {
                        fill: _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_6__/* .COLORS.BLACK */ .DM.BLACK
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNotification, {
                    message: messages,
                    type: message.type
                })
            ]
        })
    });
};


/***/ }),

/***/ 84918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K2": function() { return /* binding */ toAnchor; },
/* harmony export */   "N5": function() { return /* binding */ sortObjects; },
/* harmony export */   "OP": function() { return /* binding */ isNotEmptyString; },
/* harmony export */   "VC": function() { return /* binding */ queryParamToNumber; },
/* harmony export */   "Xl": function() { return /* binding */ queryParamToBoolean; },
/* harmony export */   "f1": function() { return /* binding */ queryParamToString; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "nz": function() { return /* binding */ updateDraggedObjects; }
/* harmony export */ });
/* unused harmony export strollToElement */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82222);


var sortObjects = function() {
    var objects = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sortedProperties = arguments.length > 1 ? arguments[1] : void 0, currentSortDirection = arguments.length > 2 ? arguments[2] : void 0;
    var firstObjectToSort = objects[0];
    if (firstObjectToSort) {
        sortedProperties.forEach(function(propertyKey) {
            var firstValueToSortType = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(firstObjectToSort[propertyKey], Date) ? "date" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(firstObjectToSort[propertyKey]);
            var sortFunction = resolveSortFunction(firstValueToSortType);
            objects = objects === null || objects === void 0 ? void 0 : objects.sort(function(a, b) {
                return sortFunction(a, b, propertyKey, currentSortDirection);
            });
        });
    }
    return objects;
};
var numberSort = function(a, b, propertyKey, currentSortDirection) {
    var numberA = Number(a[propertyKey]);
    var numberB = Number(b[propertyKey]);
    return currentSortDirection === "ascending" ? numberA - numberB : numberB - numberA;
};
var stringSort = function(a, b, propertyKey, currentSortDirection) {
    var stringA = String(a[propertyKey]).toUpperCase() // ignore upper and lowercase
    ;
    var stringB = String(b[propertyKey]).toUpperCase() // ignore upper and lowercase
    ;
    if (stringA < stringB) {
        return currentSortDirection === "ascending" ? -1 : 1;
    }
    if (stringA > stringB) {
        return currentSortDirection === "ascending" ? 1 : -1;
    }
    return 0;
};
var dateSort = function(a, b, propertyKey, currentSortDirection) {
    var dateA = a[propertyKey];
    var dateB = b[propertyKey];
    if (dateA < dateB) {
        return currentSortDirection === "ascending" ? -1 : 1;
    }
    if (dateA > dateB) {
        return currentSortDirection === "ascending" ? 1 : -1;
    }
    return 0;
};
var resolveSortFunction = function(firstValueToSortType) {
    var sortFunction;
    switch(firstValueToSortType){
        case "number":
            // Sort as a Number
            sortFunction = numberSort;
            break;
        case "date":
            sortFunction = dateSort;
            break;
        case "string":
        default:
            // Sort as a string
            sortFunction = stringSort;
            break;
    }
    return sortFunction;
};
var updateDraggedObjects = function(dragItem, dropItem, items) {
    var dragDirection = dragItem.index < dropItem.index ? "Down" : "Up";
    return items.reduce(function(agg, item) {
        switch(dragDirection){
            case "Up":
                updateDraggedObjectUp(item, dragItem, dropItem);
                break;
            case "Down":
                updateDraggedObjectDown(item, dragItem, dropItem);
                break;
        }
        return agg;
    }, items);
};
var updateDraggedObjectUp = function(item, param, param1) {
    var dragIndex = param.index, dropIndex = param1.index;
    if (item.order === dragIndex) {
        item.order = dropIndex;
    } else if (item.order < dropIndex) {
    // Do nothing!
    } else if (item.order > dragIndex) {
    // Do nothing!
    } else {
        item.order = item.order + 1;
    }
    return item;
};
var updateDraggedObjectDown = function(item, param, param1) {
    var dragIndex = param.index, dropIndex = param1.index;
    if (item.order === dragIndex) {
        item.order = dropIndex;
    } else if (item.order < dragIndex) {
    // Do nothing!
    } else if (item.order > dropIndex) {
    // Do nothing!
    } else {
        item.order = item.order - 1;
    }
    return item;
};
var isNumber = function(string) {
    return string !== undefined && !Number.isNaN(Number(string));
};
var isNotEmptyString = function(string) {
    return string !== undefined && string !== "";
};
var queryParamToNumber = function(paramValue) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!paramValue) return defaultValue;
    return Number(paramValue.toString());
};
var queryParamToString = function(paramValue) {
    return (paramValue === null || paramValue === void 0 ? void 0 : paramValue.toString()) || null;
};
var queryParamToBoolean = function() {
    var paramValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "false", defaultValue = arguments.length > 1 ? arguments[1] : void 0;
    return paramValue !== undefined ? paramValue.toString().toLowerCase() === "false" ? false : true : defaultValue;
};
var strollToElement = function(found) {
    if (found && _instanceof(found, HTMLElement)) {
        window.scroll({
            top: found.offsetTop - 100,
            behavior: "smooth"
        });
    }
};
var toAnchor = function(text) {
    return text.replace(/\s/g, "_").replace(/\?/g, "").replace(/!/g, "").replace(/##/g, "#").replace(/\(/g, "").replace(/\)/g, "");
};


/***/ })

}]);